// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"c6fcb745","147":"fb6e7c3c","216":"8d70a92a","307":"7eb8af18","313":"c9c3ca41","352":"f6474f61","475":"5419728e","648":"99bddb82","740":"e4652321","862":"8d63e92d","938":"b21a2a84","951":"018b03f4"}[chunkId] + ".chunk.js";
};